module.exports = __webpack_public_path__ + "media/banners/opony-felgi-menu-27797211.png";